import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/mutate.ts';
import { App } from './App.tsx';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);

// THE SERVICE WORKER CACHES THE SHELL AND NEVER THE DATA.
// Planning is the server's opinion about facts other people are changing; a cached calendar is a
// calendar that lies. Only the app shell is precached, so the app opens offline and then says it
// cannot reach the server — which is the honest failure.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* a failed SW must not break the app */ });
  });
}
